import { compareHelpers } from '@approvalmax/utils';
import { statics } from 'modules/common';
import { messages as countryNames } from 'shared/constants/countryNames';
import { CountryIsoCode, CurrencyIsoCode } from 'shared/data/webApp/v2';

import { isRestrictedCountry } from './EditCounterpartyPaymentDetailsPopupContent.helpers';

export const kbLink = 'https://support.approvalmax.com/portal/en/kb/articles/what-is-contact-payment-details';

// TODO: countries will be received from BE later
export const countries = Object.values(CountryIsoCode)
    .reduce<{ id: CountryIsoCode; name: string }[]>((acc, country) => {
        if (isRestrictedCountry(country)) {
            return acc;
        }

        const countryName = country in countryNames ? countryNames[country] : country;

        acc.push({
            id: country,
            name: countryName,
        });

        return acc;
    }, [])
    .sort((a, b) => compareHelpers.stringComparator2Asc(a.name, b.name));

// TODO: currencies will be received from BE later
export const currencyList = [
    CurrencyIsoCode.GBP,
    CurrencyIsoCode.USD,
    CurrencyIsoCode.EUR,
    CurrencyIsoCode.AUD,
    CurrencyIsoCode.BHD,
    CurrencyIsoCode.CNY,
    CurrencyIsoCode.CZK,
    CurrencyIsoCode.DKK,
    CurrencyIsoCode.HKD,
    CurrencyIsoCode.HUF,
    CurrencyIsoCode.INR,
    CurrencyIsoCode.IDR,
    CurrencyIsoCode.ILS,
    CurrencyIsoCode.JPY,
    CurrencyIsoCode.KES,
    CurrencyIsoCode.MYR,
    CurrencyIsoCode.MXN,
    CurrencyIsoCode.NZD,
    CurrencyIsoCode.NOK,
    CurrencyIsoCode.PHP,
    CurrencyIsoCode.PLN,
    CurrencyIsoCode.QAR,
    CurrencyIsoCode.RON,
    CurrencyIsoCode.SAR,
    CurrencyIsoCode.SGD,
    CurrencyIsoCode.ZAR,
    CurrencyIsoCode.SEK,
    CurrencyIsoCode.CHF,
    CurrencyIsoCode.THB,
    CurrencyIsoCode.TRY,
    CurrencyIsoCode.UGX,
    CurrencyIsoCode.AED,
    CurrencyIsoCode.CAD,
];

export const currencies = currencyList.map((currency) => ({
    id: currency,
    name: statics.currency.findCurrencyByCode(currency)?.text ?? currency,
}));

export const currenciesForConfirmationOfPayee = [
    {
        id: CurrencyIsoCode.GBP,
        name: statics.currency.findCurrencyByCode(CurrencyIsoCode.GBP)?.text ?? CurrencyIsoCode.GBP,
    },
];

export const countriesForConfirmationOfPayee = [
    {
        id: CountryIsoCode.GB,
        name: countryNames[CountryIsoCode.GB],
    },
];

export const incorrectAccountNameCode = 'AV300';
export const fasterPaymentsPaymentMethod = 'Faster Payments';
export const chapsPaymentMethod = 'CHAPS';
